export default axios => ({
  getList () {
    return axios.get('/procedure')
  },
  getItem (id) {
    return axios.get(`/procedure/${id}`)
  },
  update (id, payload) {
    return axios.patch(`/procedure/${id}`, payload)
  },
  delete (id) {
    return axios.delete(`/procedure/${id}`)
  },
  create (payload) {
    return axios.post('/procedure', payload)
  }
})
